import React, {useState} from 'react';
import {classes, style} from './doppe-action-type-share-widget.st.css';
import {ButtonType, useObservableValue} from '@wix/devzai-utils-react';
import {
    doppeHideableValueGetValue,
    doppeHideableValueGetVisibleValue
} from '../../../client-server-common/types/doppe-hideable-value';
import {
    DoppeActionTypeWidgetInnerButton
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {DoppeActionTypeShare} from '../doppe-action-type-share';
import {CommonClasses} from '@wix/devzai-common-client';
import {clipboardCopy} from '@wix/devzai-utils-dom';
import {
    DoppeActionType,
    useWidgetRenderingContext
} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapper
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper/doppe-action-type-widget-content-layout-new-wrapper';
import {
    DoppeActionTypeWidgetContentLayoutContentAlignment
} from '../../../components/doppe-action-type-widget-content-layout-new/doppe-action-type-widget-content-layout-new';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';

export const DoppeActionTypeShareWidget = React.memo(function DoppeActionTypeShareWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeShare.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    const {
        renderingInnerStateController
    } = useWidgetRenderingContext();

    const actionSettings = actionContext.action.settings;

    const {
        shareButtonText,
        shareLink,
        shareImage,
        description,
    } = actionSettings;

    const shareTitle = doppeHideableValueGetVisibleValue(actionSettings.shareTitle, '');

    const showShareExperience = useObservableValue(renderingInnerStateController)
    const [isCopied, setIsCopied] = useState(false);

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            {
                !showShareExperience ?
                    <DoppeActionTypeWidgetContentLayoutNewWrapper
                        contentAlignment={DoppeActionTypeWidgetContentLayoutContentAlignment.Default}
                        mainMedia={shareImage ? (
                            <DoppePageMediaView
                                className={style(classes.mainImage, {})}
                                mediaResource={shareImage}
                                layoutSpec={{autoHeight: true, maxHeight: 360}}
                                widthSpec={{contentRelativeWidth: 1}}
                                mediaResizeMode={HtmlObjectResizeMode.Cover}
                            />
                        ) : null}
                        footer={<DoppeActionTypeWidgetInnerButton
                            className={style(classes.linkButton)}
                            buttonType={ButtonType.NormalButton}
                            onClick={() => {
                                actionContext.reportGoalAchieved();
                                if (navigator.share) {
                                    navigator.share({
                                        title: shareTitle,
                                        url: shareLink,
                                        text: shareTitle,
                                    })
                                } else {
                                    renderingInnerStateController.setValue(true);
                                }

                            }}
                        >
                            {shareButtonText}
                        </DoppeActionTypeWidgetInnerButton>}
                    >
                        <DoppeActionTypeWidgetInnerTitle
                            className={style(classes.productName, {})}
                        >
                            {doppeHideableValueGetValue(shareTitle)}
                        </DoppeActionTypeWidgetInnerTitle>
                        <DoppeActionTypeWidgetInnerDescription
                            className={style(classes.productDescription, {})}
                        >
                            {description}
                        </DoppeActionTypeWidgetInnerDescription>
                    </DoppeActionTypeWidgetContentLayoutNewWrapper>
                    :
                    <DoppeActionTypeWidgetContentLayoutNewWrapper
                        footer={
                            <DoppeActionTypeWidgetInnerButton
                                className={style(classes.shareLinkButton)}
                                disabled={isCopied}
                                buttonType={ButtonType.NormalButton}
                                onClick={() => {
                                    clipboardCopy(shareLink);
                                    setIsCopied(true);
                                }}
                            >
                                {isCopied ? 'Copied' : 'Copy Link'}
                            </DoppeActionTypeWidgetInnerButton>
                        }
                    >
                        <a
                            href={shareLink}
                            target={'_blank'}
                            className={style(classes.sharedLink, {}, CommonClasses.ellipsis)}
                        >
                            {shareLink}
                        </a>
                    </DoppeActionTypeWidgetContentLayoutNewWrapper>

            }
        </DoppeActionTypeWidgetLayout>
    );
});